export default __webpack_public_path__ + "18492d4e5ae7ba791423921306dffd57.svg";